var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEditBox = function SvgEditBox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#edit_box_svg__a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    d: "M20.8 0H0v24.108L6 19H0h20.8c1.12 0 1.68 0 2.109-.218a2 2 0 0 0 .874-.874C24 17.48 24 16.92 24 15.8V3.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C22.48 0 21.92 0 20.8 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m7.522 10.535.007-.007 4.667-4.667 2-2a.667.667 0 0 1 .943 0l2 2c.26.26.26.683 0 .943l-6.667 6.667a.667.667 0 0 1-.471.195H8a.667.667 0 0 1-.667-.667v-2a.67.67 0 0 1 .188-.464ZM10 12.056l3.724-3.723-1.058-1.058L8.943 11l1.058 1.057Zm3.61-5.723 1.056 1.057 1.058-1.057-1.058-1.058-1.057 1.058Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "edit_box_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgEditBox;